module.exports = __webpack_public_path__ + "components/page-header/static/surf-badge--dark-e6ce4aea45f4d16b1289d035f6ae9f78.svg";